// @flow
import type { Preferences, User } from '../services/User'
import { getDefaultPreferenceObject } from '../services/User'
import _ from 'lodash'

const defaultPreferenceObject = getDefaultPreferenceObject()

export default {
  userPreferences: (state: any, getters: any, rootState: any, rootGetters: any): Preferences => {
    const user = rootGetters.currentUserObj
    return _.extend({}, defaultPreferenceObject, user ? user.preferences || {} : {})
  },

  // Guaranteed to return true eventually
  userPrefsInitialized: (state: any): Preferences => {
    return state.user.itemsInitialized || state.allowDefaultPrefUse
  },
  currentUserObj: (state: any): ?User => {
    return _.find(state.user.items, userItem => userItem.name === state.currentUser)
  }
}
